import { render, staticRenderFns } from "./ThePersonalMain.vue?vue&type=template&id=71ef03c7&"
import script from "./ThePersonalMain.vue?vue&type=script&lang=js&"
export * from "./ThePersonalMain.vue?vue&type=script&lang=js&"
import style0 from "./ThePersonalMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports